import { Checkbox, Toggle } from '@silvertours/front-shared';
import { ToggleWrapper } from './OneWayToggle.styles';

type Props = {
  type?: 'checkbox' | 'toggle';
  id: string;
  label: string;
  checked: boolean;
  onChange: () => void;
};

const OneWayToggle = ({ type = 'checkbox', ...rest }: Props) => (
  <ToggleWrapper $isVisuallyAligned={type === 'toggle'}>
    {type === 'toggle' ? <Toggle {...rest} /> : <Checkbox {...rest} />}
  </ToggleWrapper>
);

export { OneWayToggle };
